<template>
    <div class="submit-account" :class="lang">
<!--        <img class="icon" v-if="bgColor != 'black-theme'" src="../../../assets/images/open-account/Group 1738@3x.png" />-->
        <img class="icon" src="../../../assets/images/account-activation-3.png" />
        <span class="message">{{ isAddOpen == 1 ? $t('openInstitutionServices.g000028') : $t("submitAccount.tips") }}</span>
        <div class="text-box">
          <p class="text">{{ $t('mki18n.t00023') }}</p>
          <p class="text">{{ $t('mki18n.t00024') }}</p>
          <p class="text">{{ $t('mki18n.t00025') }} <a class="link" @click="showService">{{ $t('check_progress.status_tip_next') }}</a></p>
        </div>
        <OpenAccountStep v-if="isAddOpen != 1" class="account-step"></OpenAccountStep>
        <nav-buttons
            :isFixed="false"
            :showPrev="false"
            :nextText="$t('submitAccount.text')"
            customClass="operation"
            @on-next="handleComplete"
        />
    </div>
  </template>

  <script>
  import navButtons from '../components/navButtons.vue'
  import { Toast } from "vant";
  import { getBrowser } from "@/utils/browser";
  import { closeWebView } from "@/utils/hybirdMethods";
  import OpenAccountStep from "@/components/OpenAccountStep.vue";
  import bus from "@/utils/bus";
  export default {
    name: 'SubmitAccount',
    components: {
      navButtons,
      OpenAccountStep
    },
    data(){
      return {
        acceptance_sn:'',
        lang: 'zh-CN',
        isAddOpen: '', //
      }
    },
    created() {
      this.init()
      this.getLang();
    },
    computed: {
      bgColor() {
        return this.$store.getters["common/bgColor"];
      },
    },
    methods: {
      init(){
        this.$apis.getAccountAcceptanceSnApi().then(res =>{
           if(res){
             const { acceptance_sn } = res
             this.acceptance_sn = acceptance_sn
           }
        })
        this.$apis.accountSituationV2({
          hideFields: 'config_data'
        }).then(res =>{
          const{ extra_open_info_hb, extra_open_info_hk } = res
          this.isAddOpen = res.account_status == 6 ? 1 : '';
        })
      },
      getLang() {
        this.lang = localStorage.getItem('localLang') || 'zh-CN';
      },
      handleComplete() {
        // 这里可以添加点击完成按钮后的逻辑，比如关闭页面或跳转
        const browser = getBrowser()
        const isAPP = browser.isApp;
        if(isAPP){
          closeWebView();
        }else{
          const toastLoading = Toast.loading({
            duration: 0,
            forbidClick: true,
            loadingType: "spinner",
            message: this.$t("common.loading_text")
          });
          this.$router.push({
            path:'/open-account/home'
          }).finally(() =>{
            toastLoading.clear()
          })
        }
      },
      showService(){
        bus.$emit('showService')
      }
    }
  }
  </script>

  <style lang="less">
  .submit-account {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 94px;
    box-sizing: border-box;
    background: white;
    min-height: 100vh;
    .account-step{
      margin: 0 48px 60px;
    }
    .icon {
      width: 120px;
      height: 120px;
    }
    .message {
      width: 290px;
      font-size: 40px;
      font-weight: 500;
      color: #17161c;
      line-height: 40px;
      margin: 38px 0px;
    }
    .text-box{
      box-sizing: border-box;
      line-height: 40px;
      margin: 44px 44px 60px;
      padding-bottom: 60px;
      border-bottom: 0.5px solid #f3f3f3;
      .text{
        margin-bottom: 10px;
        &.tc{
          text-align: center;
        }
        .link{
          color: #328CF4;
          text-decoration: underline;
        }
      }
    }
    
    &.en {
      .message {
        width: 500px;
        text-align: center;
        line-height: 50px;
      }
    }
  }
  .black-theme {
    .submit-account {
      background: #1B1C24 !important;
      .message, .detail {
        color: white;
      }
      .text-box {
        color: #fff;
        border-bottom: 0.5px solid rgba(255,255,255,.1);
      }
    }
  }
  </style>
